@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: container from "../../styles/composable/layout.module.css";
    padding-block: var(--spacer-80) var(--spacer-40);

    ul {
        padding-left: 0;
    }

    li::marker {
        font-size: 0;
    }
}

.nav {
    composes: grid from "../../styles/composable/layout.module.css";
    margin-bottom: var(--spacer-40);

    h3 {
        margin-bottom: var(--spacer-16);
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: var(--spacer-16);
    }
}

.desktopNav {
    composes: nav;

    @media ($below-mobile) {
        display: none !important;
    }
}

.mobileNav {
    composes: nav;

    @media ($above-mobile) {
        display: none !important;
    }
}

.link,
.richText a {
    font: var(--font-s-16);
    text-decoration: none;
    text-underline-offset: 0.1875em;

    &:hover {
        text-decoration: underline;
    }
}

.richText {
    p {
        margin-block: var(--spacer-8);
        font: var(--font-s-14);

        &:first-child {
            font: var(--font-s-16);
        }
    }
}

.navPanel {
    grid-column: span 3;
    border: 1px solid transparent;

    @media ($above-mobile) {
        &:has(+ .navPanel) {
            border-right-color: var(--navy);
        }
    }

    @media ($below-mobile) {
        grid-column: span 4;
        border-bottom-color: var(--pale-navy);

        &:first-child {
            border-top-color: var(--pale-navy);
            padding-top: var(--spacer-16);
        }

        [data-expanded="true"] {
            padding-bottom: var(--spacer-16);
        }
    }
}

.expandButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font: var(--font-button-16);
    text-transform: uppercase;

    [aria-disabled="true"] {
        cursor: default;
    }

    svg {
        width: 1.5em;
    }
    @media ($above-mobile) {
        svg {
            display: none;
        }
    }
}

.social {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-block: var(--spacer-24);

    [slot="description"] {
        margin-bottom: var(--spacer-8);
        font: var(--font-h-20);

        @media ($below-mobile) {
            text-align: center;
        }
    }

    form {
        min-width: 33%;

        @media ($below-tablet) {
            min-width: 50%;
        }

        @media ($below-mobile) {
            min-width: 100%;
        }
    }

    button {
        margin-right: 1px;
        border-radius: 0 var(--border-radius-sm) var(--border-radius-sm) 0;
    }

    @media ($below-mobile) {
        flex-direction: column;
        align-items: center;
        gap: var(--spacer-24);
    }
}

.logo {
    margin-block: var(--spacer-16);
}

.legal {
    font: var(--font-p-12);

    p {
        font: var(--font-p-12);
    }

    a:hover {
        text-decoration: underline;
    }

    ul {
        display: flex;
        justify-content: center;
        gap: var(--spacer-16);
        flex-wrap: wrap;

        @media ($below-mobile) {
            li:first-child {
                width: 100%;

                * {
                    text-align: center;
                }
            }
        }
    }
}

:global(.grecaptcha-badge) {
    visibility: hidden;
}

.grlegal {
    padding-top: 0.5em;
    font-size: 10px;

    a {
        color: inherit;
    }
}
